import { useUserSessionStore } from "@/store/userSession.js"

import * as accountsApi from "@/api/accountsApi.js"
import * as commentsApi from "@/api/commentsApi.js"
import * as postApi from "@/api/postApi.js"

import * as sentryReporter from "@/services/sentryReporter.js"

import { postableTypes } from "@/constants/postables.js"

export const setPostablesAuthorBadges = async (postables, postableType) => {
  const userSessionStore = useUserSessionStore()
  if (!postables.length || !userSessionStore.isLoggedIn) {
    return
  }

  const endpoint = postableType === postableTypes.POST ? postApi.badges : commentsApi.badges
  const prop = postableType === postableTypes.POST ? "post_id" : "comment_id"

  try {
    const { badges } = await endpoint(postables.map((p) => p.id))
    badges.forEach((b) => (postables.find((p) => p.id === b[prop]).badges = b.badges))
  } catch (err) {
    sentryReporter.reportError(err)
  }
}

export const setPostablesLikes = async (postables, postableType) => {
  const userSessionStore = useUserSessionStore()

  if (!userSessionStore.isLoggedIn || !postables.length) {
    return
  }

  const endpoint = postableType === postableTypes.POST ? accountsApi.likedPosts : accountsApi.likedComments

  try {
    const { likes } = await endpoint(postables.map((p) => p.id))
    const likedCommentsIds = likes.map((l) => l.likeable_id)
    postables.forEach((p) => (p.isLikedByCurrentUser = likedCommentsIds.includes(p.id)))
  } catch (err) {
    sentryReporter.reportError(err)
  }
}

export const setPostablesLikesAndAuthorBadges = async (postables, postableType) => {
  setPostablesLikes(postables, postableType)
  await setPostablesAuthorBadges(postables, postableType)
}
